import { render } from "./OpenAssistantBotSettings.vue?vue&type=template&id=8f4ba222"
import script from "./OpenAssistantBotSettings.vue?vue&type=script&lang=js"
export * from "./OpenAssistantBotSettings.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__